<template>
  <div id="personal">
    <navbar :data="0"/>
     <router-view></router-view>
    <Footer/>
<!--    <div class="col-12" v-if="dialogs[0].value">-->
<!--      <login :dialog="dialogs[0].value" @register="reverseDialog($event)" @closeDialog="reverseDialog($event)"/>-->
<!--    </div>-->
<!--    <div class="col-12" v-if="dialogs[1].value">-->
<!--      <register :dialog="dialogs[1].value" @closeDialog="reverseDialog($event)"/>-->
<!--    </div>-->
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Footer from '../../components/core/Footer'

// import PopularBundles2 from '../PopularBundles2'
// import FeatureController from '../FeatureController'
import utils from '../../shared/utils'
import UserNumbersRepository from '../../repositories/UserNumbersRepository'
// import BundlesCategoriesRepository from '../../repositories/BundlesCategoriesRepository'
// import FooterAppsRepository from '../../repositories/FooterAppsRepository'
export default {
  name: 'Personal',
  components: { Footer, Navbar },
  data () {
    return {
      userNumbersRepo: new UserNumbersRepository(),
      reverseDialog: utils.changeDialogStatus,
      // bundlesCategoriesRepo: new BundlesCategoriesRepository(),
      // footerAppsRepo: new FooterAppsRepository(),
      dialogs: utils.dialogs
    }
  },
  created () {
    this.$watch(() => {
      return this.$store.state.user.token
    }, (val) => {
      this.fetchNumbers()
    })
    // this.getBundles()
    // this.getApps()
    this.$store.state.activeNav = 0
  },
  mounted () {
  },
  methods: {
    async fetchNumbers () {
      try {
        const response = await this.userNumbersRepo.get()
        if (response.status === 200) {
          if (response.data.length) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].isMain === 1) {
                this.$store.state.mainGsm = response.data[i].gsm
              }
            }
          }
        }
      } catch (e) {
      }
    }
    // async getBundles () {
    //   try {
    //     const response = await this.bundlesCategoriesRepo.get()
    //     if (response.status === 200) {
    //       // console.log('personal', response)
    //       this.$store.state.bundleCategories = []
    //       for (let i = 0; i < response.data.length; i++) {
    //         this.$store.state.bundleCategories.push({ title: response.data[i].title, url: '/bundles/' + response.data[i].id, id: response.data[i].id })
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
    // async getApps () {
    //   try {
    //     const response = await this.footerAppsRepo.get()
    //     if (response.status === 200) {
    //       // this.footer[3].info = []
    //       this.$store.state.mtnApps = []
    //       for (let i = 0; i < response.data.length; i++) {
    //         if (i > 3) {
    //           return
    //         }
    //         this.$store.state.mtnApps.push({ title: response.data[i].title, url: response.data[i].link, id: response.data[i].id })
    //       }
    //       this.$forceUpdate()
    //     }
    //   } catch (e) {
    //     return e
    //   }
    // }
  }
}
</script>
<style lang="scss">
@import "src/assets/sass/main";
#personal {
  background-image: linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.9));
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.9));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.9));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.9));
}
</style>
